import * as React from 'react';
import { ThemeContext } from '../context/themeContext';
const LionEnergy = (props) => {
  const { theme } = React.useContext(ThemeContext);
  const fill = theme === 'dark' ? 'white' : 'black';
  return (
    <svg
      width={70}
      height={89}
      viewBox="0 0 64 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M51.2762 27.5298L52.7726 24.735L45.8501 23.0558L51.2762 27.5298Z"
        fill={fill}
      />
      <path
        d="M58.3876 28.8342L64.0004 30.8852L62.6907 37.4072L63.627 41.3206L61.9436 40.3879L50.9019 40.7601L59.3239 38.1512L61.3807 33.3081L58.3876 28.8342Z"
        fill={fill}
      />
      <path
        d="M23.0624 58.7555L5.82764 64.6312L29.1579 43.8233L32.5876 57.2539L52.8329 80.2328L23.0624 58.7555Z"
        fill={fill}
      />
      <path
        d="M57.3665 48.2293L61.3823 48.9616L61.9423 45.0485L58.9492 47.2824L45.1007 39.8308L39.1117 43.9298L36.1186 40.7604L42.6677 28.8345L33.6856 24.9214L40.4648 14.3201L56.7029 22.3126L45.6612 4.60839L44.914 9.64017L34.6219 0.134399L31.626 7.03132L18.5274 4.4197L25.2636 10.198L4.49262 20.822L18.7745 18.2277L1.12297 33.8663L11.9784 30.8828L0 48.0292L8.79541 41.321L3.18257 60.5157L30.1296 36.2895L38.2327 55.4981L55.0195 75.9828L54.0832 64.6147L60.0722 68.1559L53.8965 57.3459L53.5231 47.4714L57.3665 48.2009V48.2293Z"
        fill={fill}
      />
    </svg>
  );
};

export default LionEnergy;
